/**
 * @tabler/icons-react v2.44.0 - MIT
 */

import createReactComponent from '../createReactComponent.js';

var IconCut = createReactComponent("cut", "IconCut", [
  ["path", { d: "M7 17m-3 0a3 3 0 1 0 6 0a3 3 0 1 0 -6 0", key: "svg-0" }],
  ["path", { d: "M17 17m-3 0a3 3 0 1 0 6 0a3 3 0 1 0 -6 0", key: "svg-1" }],
  ["path", { d: "M9.15 14.85l8.85 -10.85", key: "svg-2" }],
  ["path", { d: "M6 4l8.85 10.85", key: "svg-3" }]
]);

export { IconCut as default };
//# sourceMappingURL=IconCut.js.map
